var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import services from '../../services';
var PushTemplateService = services.PushTemplateService, DatasetService = services.DatasetService;
export var loadPushTemplates = function (appId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var pushTemplates, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: 'LOAD_PUSH_TEMPLATES_REQUEST' });
                return [4 /*yield*/, PushTemplateService.getPushTemplates(appId)];
            case 1:
                pushTemplates = (_a.sent()).objects;
                dispatch({
                    type: 'LOAD_PUSH_TEMPLATES_SUCCESS',
                    pushTemplates: pushTemplates,
                    appId: appId,
                });
                return [3 /*break*/, 3];
            case 2:
                error_1 = _a.sent();
                console.error(error_1);
                dispatch({
                    type: 'LOAD_PUSH_TEMPLATES_FAILURE',
                });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var loadSelectedPushTemplate = function (templateId, appId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var template, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'LOAD_SELECTED_PUSH_TEMPLATE_DATA_REQUEST' });
                    return [4 /*yield*/, PushTemplateService.getPushTemplate(templateId, appId)];
                case 1:
                    template = (_a.sent()).object;
                    dispatch({
                        type: 'LOAD_SELECTED_PUSH_TEMPLATE_DATA_SUCCESS',
                        templateData: {
                            templateId: template.id,
                            datasetId: template.dataset,
                            patchId: template.view_patch,
                            rowId: '',
                            meta: template.meta,
                        },
                    });
                    return [2 /*return*/, template];
                case 2:
                    error_2 = _a.sent();
                    console.error(error_2);
                    dispatch({
                        type: 'LOAD_SELECTED_PUSH_TEMPLATE_DATA_FAILURE',
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/, null];
            }
        });
    }); };
};
export var loadSelectedPushTemplateDetails = function (pushDetails) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                dispatch({
                    type: 'LOAD_SELECTED_PUSH_TEMPLATE_DATA_SUCCESS',
                    templateData: pushDetails,
                });
            }
            catch (error) {
                console.error(error);
            }
            return [2 /*return*/];
        });
    }); };
};
export var clearSelectedPushTemplateDetails = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        try {
            dispatch({
                type: 'LOAD_SELECTED_PUSH_TEMPLATE_DATA_SUCCESS',
                templateData: {
                    templateId: '',
                    datasetId: '',
                    patchId: '',
                    rowId: '',
                    meta: [],
                },
            });
        }
        catch (error) {
            console.error(error);
        }
        return [2 /*return*/];
    });
}); }; };
export var loadPushTemplateToEdit = function (templateId, appId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var template, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'LOAD_TEMPLATE_TO_EDIT_REQUEST' });
                    return [4 /*yield*/, PushTemplateService.getPushTemplate(templateId, appId)];
                case 1:
                    template = (_a.sent()).object;
                    dispatch({
                        type: 'LOAD_TEMPLATE_TO_EDIT_SUCCESS',
                        template: template,
                    });
                    return [3 /*break*/, 3];
                case 2:
                    error_3 = _a.sent();
                    console.error(error_3);
                    dispatch({
                        type: 'LOAD_TEMPLATE_TO_EDIT_FAILURE',
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
export var clearPushTemplateToEdit = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        try {
            dispatch({
                type: 'LOAD_TEMPLATE_TO_EDIT_SUCCESS',
            });
        }
        catch (error) {
            console.error(error);
        }
        return [2 /*return*/];
    });
}); }; };
export var createPushTemplateItem = function (pushTemplateParams, appId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var template, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'CREATE_PUSH_TEMPLATE_REQUEST' });
                    return [4 /*yield*/, PushTemplateService.createPushTemplate(pushTemplateParams, appId)];
                case 1:
                    template = (_a.sent()).object;
                    dispatch({
                        type: 'CREATE_PUSH_TEMPLATE_SUCCESS',
                        template: template,
                    });
                    return [2 /*return*/, true];
                case 2:
                    error_4 = _a.sent();
                    console.error(error_4);
                    dispatch({
                        type: 'CREATE_PUSH_TEMPLATE_FAILURE',
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/, false];
            }
        });
    }); };
};
export var updatePushTemplateItem = function (templateId, pushTemplateParams, appId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var template, error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'UPDATE_PUSH_TEMPLATE_REQUEST' });
                    return [4 /*yield*/, PushTemplateService.updatePushTemplate(templateId, pushTemplateParams, appId)];
                case 1:
                    template = (_a.sent()).object;
                    dispatch({
                        type: 'UPDATE_PUSH_TEMPLATE_SUCCESS',
                        template: template,
                    });
                    return [2 /*return*/, true];
                case 2:
                    error_5 = _a.sent();
                    console.error(error_5);
                    dispatch({
                        type: 'UPDATE_PUSH_TEMPLATE_FAILURE',
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/, false];
            }
        });
    }); };
};
export var deletePushTemplate = function (templateId, appId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var error_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'DELETE_PUSH_TEMPLATE_REQUEST' });
                    return [4 /*yield*/, PushTemplateService.deletePushTemplate(templateId, appId)];
                case 1:
                    _a.sent();
                    dispatch({
                        type: 'DELETE_PUSH_TEMPLATE_SUCCESS',
                        templateId: templateId,
                    });
                    return [2 /*return*/, true];
                case 2:
                    error_6 = _a.sent();
                    console.error(error_6);
                    dispatch({
                        type: 'DELETE_PUSH_TEMPLATE_FAILURE',
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/, false];
            }
        });
    }); };
};
export var selectChosenPushTemplateId = function (pushTemplateId) {
    return function (dispatch) {
        try {
            dispatch({
                type: 'SELECT_CHOSEN_PUSH_TEMPLATE_ID_SUCCESS',
                pushTemplateId: pushTemplateId,
            });
            return true;
        }
        catch (error) {
            console.error(error);
        }
        return false;
    };
};
export var selectSelectedPushTemplateId = function (selectedPushTemplateId) {
    return function (dispatch) {
        try {
            dispatch({
                type: 'SELECT_PUSH_TEMPLATE_ID_SUCCESS',
                selectedPushTemplateId: selectedPushTemplateId,
            });
            return true;
        }
        catch (error) {
            console.error(error);
        }
        return false;
    };
};
export var selectSelectedPatchId = function (selectedPatchId) {
    return function (dispatch) {
        try {
            dispatch({
                type: 'SELECT_PATCH_ID_SUCCESS',
                selectedPatchId: selectedPatchId,
            });
            return true;
        }
        catch (error) {
            console.error(error);
        }
        return false;
    };
};
export var selectSelectedRowId = function (selectedRowId) {
    return function (dispatch) {
        try {
            dispatch({
                type: 'SELECT_ROW_ID_SUCCESS',
                selectedRowId: selectedRowId,
            });
            return true;
        }
        catch (error) {
            console.error(error);
        }
        return false;
    };
};
export var selectSelectedDatasetId = function (selectedDatasetId) {
    return function (dispatch) {
        try {
            dispatch({
                type: 'SELECT_DATASET_ID_SUCCESS',
                selectedDatasetId: selectedDatasetId,
            });
            return true;
        }
        catch (error) {
            console.error(error);
        }
        return false;
    };
};
export var selectSelectedMappedArray = function (mappedArray) {
    return function (dispatch) {
        try {
            dispatch({
                type: 'SELECT_MAPPED_ARRAY_SUCCESS',
                mappedArray: mappedArray,
            });
            return true;
        }
        catch (error) {
            console.error(error);
        }
        return false;
    };
};
export var getDatasetRows = function (datasetId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var datasetRows, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: 'GET_DATASET_ROWS_REQUEST' });
                return [4 /*yield*/, DatasetService.getRows(datasetId)];
            case 1:
                datasetRows = (_a.sent()).objects;
                dispatch({
                    type: 'GET_DATASET_ROWS_SUCCESS',
                    datasetRows: datasetRows,
                });
                return [2 /*return*/, datasetRows];
            case 2:
                err_1 = _a.sent();
                console.error(err_1);
                dispatch({ type: 'GET_DATASET_ROWS_FAILURE' });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, false];
        }
    });
}); }; };
export var clearDatasetRows = function () { return ({
    type: 'GET_DATASET_ROWS_RESET',
}); };
